import React, { FC } from "react";

import { Autocomplete } from "@mui/material";

import TextField from "../../../components/styled/TextField";
import useTimePeriod from "../../../hooks/use-time-period";

const TimePeriodSelector: FC = () => {
  const { period, setPeriod, options } = useTimePeriod();
  return (
    <Autocomplete
      sx={{ m: 2 }}
      fullWidth
      size="small"
      value={options.find((o) => o.period.toMillis() === period.toMillis())}
      getOptionLabel={(option) => option.label}
      options={options}
      renderInput={(params) => <TextField {...params} />}
      onChange={(_, option) => setPeriod(option.period)}
      disableClearable
    />
  );
};
export default TimePeriodSelector;
